import { useCallback, useState } from 'react';
import { GridTreeDataGroupingCell } from '@mui/x-data-grid-premium';
import { dataGridPremiumColumns } from '../../../../utils/helper';
import { DataGridIdentifiers, DatagridPremiumUi } from '../../../Interface';

const TemplateItemTable = ({ items }) => {
  const [rowSelectionModel, setRowSelectionModel] = useState([]);

  const columns = () => {
    return dataGridPremiumColumns([
      {
        field: 'name',
        headerName: 'Kiválasztott template elemei',
        type: 'string',
        renderCell: (params) => {
          return <GridTreeDataGroupingCell {...params} label="" />;
        },
      },
    ]);
  };

  const getTreeDataPath = useCallback((row) => row.path, []);

  return (
    <DatagridPremiumUi
      datagridIdentifier={DataGridIdentifiers.taskListImport}
      getRowHeight={() => 'auto'}
      height={600}
      headerFilters={false}
      columns={columns()}
      slots={{
        toolbar: '',
      }}
      rows={items ?? []}
      treeData
      groupingColDef={{
        headerName: '',
        renderCell: () => null,
        width: 1,
        hideable: false,
        sortable: false,
        resizable: false,
      }}
      onRowSelectionModelChange={(newRowSelectionModel) => {
        setRowSelectionModel(newRowSelectionModel);
      }}
      rowSelectionModel={rowSelectionModel}
      getTreeDataPath={getTreeDataPath}
    />
  );
};

export default TemplateItemTable;
